export const reloadChannel = new BroadcastChannel("reload");

export function broadcastReload(path?: string) {
    if (path !== undefined) {
        reloadChannel.postMessage(path);
        location.href = path;
    } else {
        reloadChannel.postMessage(null);
        location.reload();
    }
}
